import * as constActions from './const';
import initialState from './initialState';

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constActions.DISPATH_SELECTED_ROWS:
      if (
        state.globalSelectedRows.filter(function (e) {
          return e.actionPageTabType == action.actionPageTabType;
        }).length > 0
      ) {
        return Object.assign({}, state, {
          globalSelectedRows: state.globalSelectedRows.map((curEntityRows, index) => {
            if (curEntityRows.actionPageTabType == action.actionPageTabType) {
              return {
                actionPageTabType: action.actionPageTabType,
                selectedRows: action.selectedRows,
                isSelectAllSelected: action.isSelectAllSelected
              };
            }
            return curEntityRows;
          })
        });
      } else {
        return Object.assign({}, state, {
          globalSelectedRows: [
            ...state.globalSelectedRows,
            {
              actionPageTabType: action.actionPageTabType,
              selectedRows: action.selectedRows,
              isSelectAllSelected: action.isSelectAllSelected
            }
          ]
        });
      }
    case constActions.DISPATH_SELECTED_TAB:
      return Object.assign({}, state, {
        selectedTab: action.selectedTab
      });
    case constActions.DISPATH_TAB_TABLE_RESULTS:
      return Object.assign({}, state, {
        globalTableData: action.globalTableData
      });
    case constActions.DISPATCH_APPROVED_ROWS:
      return Object.assign({}, state, {
        globalApprovedRows: action.globalApprovedRows
      });
    case constActions.DISPATCH_SELECTED_ACTION_ROW:
      return Object.assign({}, state, {
        selectedActionData: action.selectedActionData
      });

    default:
      return state;
  }
}
